import { ILMToSAPQueue } from 'interfaces';
import { axiosPrivate } from 'services/axios';
import toast from 'features/toast';
import { BaseService } from './BaseService';

class LMToSAPQueueService extends BaseService<ILMToSAPQueue> {
  constructor() {
    super('lm-to-sap/queue');
  }

  public async pollStatus(trackingId: string) {
    try {
      const res = await axiosPrivate.get(`lm-to-sap/${trackingId}/status/`);
      return res.data;
    } catch (e) {
      toast.error(e.message);
      throw e;
    }
  }
}

export const lmToSAPQueueService = new LMToSAPQueueService();
